<template>
  <el-form
    ref="addressForm"
    :key="formKey"
    label-position="top"
    :model="address"
    :rules="rules"
  >
    <el-form-item
      v-if="formType === 'update'"
      label="Cím típusa"
      prop="type"
    >
      <el-select
        v-model="type"
        style="width: 100%"
      >
        <el-option
          value="delivery"
          label="Szállítási cím"
        />
        <el-option
          value="mailing"
          label="Levelezési cím"
        />
        <el-option
          value="billing"
          label="Számlázási cím"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="formType === 'add'"
      label="Cím típusa"
      prop="types"
    >
      <el-select
        v-model="types"
        multiple
        style="width: 100%"
      >
        <el-option
          value="delivery"
          label="Szállítási cím"
        />
        <el-option
          value="mailing"
          label="Levelezési cím"
        />
        <el-option
          value="billing"
          label="Számlázási cím"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      prop="pivot.gln_number"
      label="GLN szám"
      v-if="type === 'delivery' || types.includes('delivery')"
    >
      <el-input v-model="address.pivot.gln_number" />
    </el-form-item>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Irányítószám"
          prop="postal_code"
        >
          <el-input
            v-model="address.postal_code"
            @change="onZipChange"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Város"
          prop="city"
          v-loading="addressLoading"
        >
          <el-input
            v-model="address.city"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Ország"
          prop="country"
          v-loading="addressLoading"
        >
          <el-select
            v-model="address.country"
            value-key="id"
            style="width: 100%;"
            filterable
          >
            <el-option
              v-for="country in countries"
              :key="country.id"
              :value="country"
              :label="country.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Megye"
          prop="county"
          v-loading="addressLoading"
        >
          <el-select
            v-model="address.county"
            value-key="id"
            style="width: 100%;"
            filterable
          >
            <el-option
              v-for="county in counties"
              :key="county.id"
              :value="county"
              :label="county.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item
          label="Cím"
          prop="address"
        >
          <el-input
            v-model="address.address"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import streetSuffixes from '../../../../config/streetSuffixes';
  export default {
    props: ['defaultAddress', 'formType'],
    data() {
      return {
        types: [],
        suffixes: streetSuffixes,
        type: null,
        addressLoading: false,
        address: {
          pivot: {
            gln_number: null
          }
        },
        formKey: 0,
        rules: {
          country: [
            { required: true, message: 'Ország megadása kötekező', trigger: 'change' }
          ],
          postal_code: [
            { required: true, message: 'Irányítószám megadása kötekező', trigger: 'change' }
          ],
          city: [
            { required: true, message: 'Város megadása kötekező', trigger: 'change' }
          ],
          street: [
            { required: true, message: 'Közterület neve kötekező', trigger: 'change' }
          ],
          street_no: [
            { required: true, message: 'Házszám megadása kötekező', trigger: 'change' }
          ],
          street_suffix: [
            { required: true, message: 'Közterület jellege megadása kötekező', trigger: 'change' }
          ]
        },
      };
    },
    computed: {
      countries() {
        return this.$store.getters['country/countries'];
      },
      counties() {
        return this.$store.getters['county/counties'];
      },
    },
    watch: {
      defaultAddress: {
        handler(newVal) {
          this.type = newVal.pivot.type;
          this.address = JSON.parse(JSON.stringify(newVal));
        },
        deep: true,
      },
    },
    methods: {
      suffixFilter(value) {
        this.suffixes = streetSuffixes;
        if (value) {
          this.suffixes = this.suffixes.filter(suffix => suffix.startsWith(value));
        }
        this.address.street_suffix = value;
      },
      async onZipChange() {
        this.addressLoading = true;
        const data = await axios.get('/api/city/' + this.address.postal_code);
        if (data) {
          this.$set(this.address, 'city', data.city);
          this.$set(this.address, 'county_id', data.county_id);
          this.$set(this.address, 'county', this.counties.find(c => c.id === data.county_id));
          this.$set(this.address, 'country_id', data.country_id);
          this.$set(this.address, 'country', this.countries.find(c => c.id === data.country_id));
        } else {
          this.$set(this.address, 'city', null);
          this.$set(this.address, 'county', null);
          this.$set(this.address, 'county_id', null);
        }
        this.addressLoading = false;
      },
    },
    async beforeMount() {
      // if (this.formType === 'add') {
      //   this.rules.types = [
      //     {
      //       validator: (rule, value, callback) => {
      //         if (this.types.length === 0) {
      //           callback(new Error('Típus megadása kötekező'));
      //         } else {
      //           callback();
      //         }
      //       }, trigger: 'change'
      //     },
      //   ];
      // } else {
      //   this.rules.type = [
      //     { required: true, message: 'Típus megadása kötekező', trigger: 'change' }
      //   ];
      // }
      this.$store.dispatch('country/fetchAll');
      this.$store.dispatch('county/fetchAll');
      if (this.formType === 'update') {
        this.type = this.defaultAddress.pivot.type;
        this.address = JSON.parse(JSON.stringify(this.defaultAddress));
      }
    },
  };
</script>
